import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const OnboardingFlagKey = {
  MERCHANT_CONTEXTUAL_ONBOARDING: featureFlagKey(
    "merchant-contextual-onboarding",
  ), // Enable Contextual self-serve onboarding (default: show Calendly)
  MERCHANT_RECOVER_ONBOARDING: featureFlagKey("merchant-recover-onboarding"), // Enable Recover self-serve onboarding (default: show Calendly)
  RECOVER_PHONE_PROVISIONING_ONBOARDING: featureFlagKey(
    "recover-phone-provisioning-onboarding",
  ), // Gate the auto-fire of Recover phone number provisioning on onboarding completion (Telnyx TF today, 10DLC in future). Default OFF — onboarding completion is a no-op until the flag is turned on per team. Admin RPC trigger bypasses this flag.
  MERCHANT_ONBOARDING_AI_CHATS: featureFlagKey("merchant-onboarding-ai-chats"), // Enable AI chat sidebar in merchant onboarding flows
  MERCHANT_WALKTHROUGH: featureFlagKey("merchant-dashboard-walkthroughs"), // Enable walkthrough training flows in the merchant dashboard
  MERCHANT_DASHBOARD_ONBOARDING_PRODUCTS: featureFlagKey(
    "merchant-dashboard-onboarding-products",
  ), // Show order editing onboarding card on merchant homepage
  CONTEXTUAL_ONBOARDING: featureFlagKey("contextual-onboarding"), // Enable Contextual onboarding in marketing navigation
} as const;
